import axios from "axios";
//GET ALL CARCATAGORY BY COUNTRY
export const ADD_ADDITIONAL_CASE_DOC = "ADD_ADDITIONAL_CASE_DOC";
export const ADD_ADDITIONAL_CASE_DOC_LOADING =
"ADD_ADDITIONAL_CASE_DOC_LOADING";
export const ADD_ADDITIONAL_CASE_DOC_LOADING_FAILED =
"ADD_ADDITIONAL_CASE_DOC_LOADING_FAILED";

// HELPER ACTIONS CREATORS
//************************************** /

export const addDocumentCaseLoading = ms => ({
    type: ADD_ADDITIONAL_CASE_DOC_LOADING,
    payload: ms
    });
    
    export const addDocumentCaseLoadingFailed = ms => ({
    type: ADD_ADDITIONAL_CASE_DOC_LOADING_FAILED,
    payload: ms
    });

// RIDER PHINE NUBER
export function addDocumentCase(obj) {
    const  request = axios.post(
            `https://prod-legalemirates.wowets.com/fileService/receptionistRoutes/api/v1/cases/uploadAttachmentsByCaseId`,obj, {
                headers: { 'Authorization': 'bearer ' +localStorage.receptionistToken}
              });
        
 
    
    return dispatch => {

    dispatch(addDocumentCaseLoading());
    request
    .then(response => {   
  
    if (response.status == 200 || response.status == 201) {
     console.log(response,"response addDocumentCase")
    dispatch({
    type: ADD_ADDITIONAL_CASE_DOC,
    payload: response.data
    });
  
    } else {
      
    throw new Error(JSON.stringify(response.data.response.msg));
    }
    })
    .catch(error => {
        
    if (error.response) {
    if (error.response.status == "404") {
        console.log(error.response)
    dispatch(
        addDocumentCaseLoadingFailed(error.response.data.message)
    );
    } else {
    dispatch(addDocumentCaseLoadingFailed(error.response.data.message));
    }
    console.log(error.response.data);
    console.log(error.response.status);
    console.log(error.response.headers);
    } else if (error.request) {
    /*
    * The request was made but no response was received, `error.request`
    * is an instance of XMLHttpRequest in the browser and an instance
    * of http.ClientRequest in Node.js
    */
    dispatch(addDocumentCaseLoadingFailed(error.request));
    
    console.log(error.request);
    } else {
    // Something happened in setting up the request and triggered an Error
    console.log("Error", error.message);
    dispatch(addDocumentCaseLoadingFailed(error.message));
    }
    console.log(error);
    });
    };
    }


